import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-rest-consumed-authentication-type-dropdown',
  templateUrl: './rest-consumed-authentication-type-dropdown.component.html',
  styleUrls: ['./rest-consumed-authentication-type-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RestConsumedAuthenticationTypeDropdownComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class RestConsumedAuthenticationTypeDropdownComponent implements OnInit, OnChanges {
  @Input() formData;
  @Input() element;
  @Input() disableField;
  @Input() formGroup;
  sysGen: boolean;
  showDropdown = false;
  selectedOption: any;
  disabled: boolean;
  restConsumedAuthenticationTypeOptions: any[] = [];
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  ngOnChanges(changes: SimpleChanges): void {
    // Determine if field should be disabled based on sysgen status OR parent disableField input
    // Must re-evaluate on every change to properly enable when switching from sysgen to non-sysgen node
    if (changes['formData'] || changes['disableField']) {
      this.disabled = this.formData?.sysgen || this.disableField;
    }
    // Reload dropdown options when formData changes to update available authentication types
    if (changes['formData'] && this.formData) {
      this.loadDropdownOptions();
    }
  }

  ngOnInit(): void {
    this.loadDropdownOptions();
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setSelectedValue(value);
    this.modelValue = value;
  }
  setSelectedValue(value: any) {
    const event: any = {};
    if (value) {
      this.selectedOption = value;
      event.value = this.selectedOption;
    }
  }
  handleChange(event: any) {
    this.modelValue = event.value;
    this.onChange(this.modelValue);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  loadDropdownOptions() {
    this.showDropdown = true;
    this.restConsumedAuthenticationTypeOptions = [
      {
        name: 'Basic',
        value: 'basic'
      },
      {
        name: 'No Auth',
        value: 'no_auth'
      }
    ];
    if (this.formData?.sysgen) {
      this.restConsumedAuthenticationTypeOptions.push({
        name: 'Rappit Intra Communication (Service Account)',
        value: 'rappit_intra_communication'
      });
      this.restConsumedAuthenticationTypeOptions.push({
        name: 'Rappit Intra Communication (KMS)',
        value: 'rappit_intra_communication_kms'
      });
    }
  }
}
